import { MainHeaderMenuQuery, useMainHeaderMenuQuery } from "@src/components/organisms/MainHeader/__generated/Header.generated";
import { QueryClient } from "@tanstack/react-query";
import filter from "lodash/filter";
import getClient from "src/services/contentful/contentful";
import { IHeaderFields } from "src/types/generated/contentful";

function parseHeader({ fields }: any): IHeaderFields {
  return {
    title: fields.title,
    content: fields.content,
    menuItems: fields.menuItems,
  };
}

type GetHeaderEntries = {
  query:
    | {
        order?: string;
        limit?: number;
        skip?: number;
        select?: string;
      }
    | { [key: string]: string | number | boolean };
  preview?: boolean;
};
export default async function getHeaderMenu({
  query,
  preview = false,
}: GetHeaderEntries): Promise<IHeaderFields | null> {
  const entries = await getClient({ preview }).getEntries({
    content_type: "header",
    ...query,
  });

  //console.log("header entries", JSON.stringify(entries, null, 2));

  return entries?.items.length > 0 ? parseHeader(entries.items[0]) : null;
}

export const getHeaderMenuGraphQL = async ({
  preview,
  queryClient,
}: {
  preview: boolean;
  queryClient: QueryClient;
}) => {
  // const query = `


  // `;
  // const fetchOptions = {
  //   method: "POST",
  //   headers: {
  //     Authorization: `Bearer ${
  //       process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN || ""
  //     }`,
  //     "Content-Type": "application/json",
  //   },
  //   body: JSON.stringify({
  //     query,
  //     variables: {
  //       preview: true,
  //     },
  //   }),
  // };

  // const response = await fetch(
  //   `https://graphql.contentful.com/content/v1/spaces/${
  //     process.env.CONTENTFUL_SPACE_ID || ""
  //   }/environments/${process.env.CONTENTFUL_ENVIRONMENT || "staging"}`,
  //   fetchOptions
  // ).then((response) => response.json());


  // prefetch queries
  await queryClient.prefetchQuery(
    useMainHeaderMenuQuery.getKey({ preview }),
    // @ts-ignore
    useMainHeaderMenuQuery.fetcher({ preview })
  );

  const data = await useMainHeaderMenuQuery.fetcher({
    preview,
  });

  return await buildMenu(data);
};

const buildMenu = async (data: MainHeaderMenuQuery): Promise<any> => {
  const menuItems: any[] = [];
  if (data?.headerCollection?.items[0]?.menuItemsCollection?.items) {

    const responses = await Promise.all(
      data?.headerCollection?.items[0].menuItemsCollection.items.map(
        async (header: any) => {
          if ((header?.linkUrl )) {
            return {
              title: header?.title,
              entry: header?.entry,
              linkUrl: header?.linkUrl?.slug ?  header?.linkUrl?.slug : header?.linkUrl,
            };
            return;
          } else {
            const menuItem = await buildSubMenus(
              null,
              header,
              data?.subMenuItemCollection?.items,
              data?.menuItemCollection?.items
            );

            const t = menuItem[0] ? menuItem[0] : null;
            if (t) {
              return t;
            }
          }
        }
      )
    );

    //console.log("responses", JSON.stringify(responses[0], null, 2));

    responses.map((r) => {
      menuItems.push(r);
    });

    if (data?.headerCollection?.items[0]?.content?.items[0]) {
      const item = data?.headerCollection?.items[0]?.content.items[0];

      return {
        menuItems,
        content: {
          sys: item.sys,
          fields: item,
          __typename: item.__typename,
        },
      };
    }
  }
  return null;
};
//sys.contentType.sys.id

const buildSubMenus = async (
  subMenuItems: any,
  parent: any,
  subMenuItemsCollection: any,
  menuItemsCollection: any
) => {
  const subMenuItemz: any = [];
  if (subMenuItems) {
    subMenuItems.map(async (s: any) => {
      await Promise.all(
        filter(subMenuItemsCollection, {
          sys: { id: s?.sys?.id },
        }).map(async (sbi) => {
          const item = {
            title: sbi.title,
            entry: sbi.entry,
            linkUrl: sbi?.linkUrl?.slug ? sbi?.linkUrl?.slug : sbi?.linkUrl,
            menuItems: await buildSubMenus(
              sbi.menuItemsCollection?.items,
              sbi,
              subMenuItemsCollection,
              menuItemsCollection
            ),
          };
          subMenuItemz.push(item);
        })
      );
    });
  } else {
    // if this is the first level of submenus
    await Promise.all(
      filter(subMenuItemsCollection, {
        sys: { id: parent?.sys?.id },
      }).map(async (sbi) => {
        subMenuItemz.push({
          title: sbi.title,
          menuItems: await buildSubMenus(
            sbi.menuItemsCollection.items,
            sbi?.sys?.id,
            subMenuItemsCollection,
            menuItemsCollection
          ),
        });
      })
    );
  }

  if (subMenuItems) {
    await subMenuItems.map(async (sbi: any) => {
      if (sbi.__typename === "Page" || sbi.__typename === "MenuItem") {
        const item: any = {
          title: sbi.title,
        };
        if (sbi.slug) {
          item.linkUrl = sbi.slug ? "/" + sbi.slug : null;
        } else {
          item.linkUrl = sbi.entry.slug ? "/" + sbi.entry.slug : null;
        }
        subMenuItemz.push(item);
      }
    });
  }

  return subMenuItemz;
};
